module.exports = __webpack_public_path__ + "img/2.d3e080f0.jpg";